/* eslint-disable no-script-url */
import React, { useEffect } from "react";
import loginImg from "../Assests/Imgs/Starting a business project-amico.png";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { VALIDATION_MESSAGE } from "../../Constants/Constants";
import { UserLogin } from "../../Redux/Actions/AuthAction";
import { url } from "../../Config/Config";
import Spinner from "../DefaultComponent/Spinner";

function Login() {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const { login_status, session_loading } = useSelector(
    (state: any) => state.UserLoginDataState
  );
  interface FormInputs {
    email: string;
    password: string;
  }

  const formSchema = Yup.object().shape({
    email: Yup.string()
      .email()
      .required(VALIDATION_MESSAGE?.ANY_REQUIRED + "Email")
      .trim(VALIDATION_MESSAGE?.ANY_REQUIRED + "Email")
      .max(50),

    password: Yup.string().required(
      VALIDATION_MESSAGE?.ANY_REQUIRED + "Password"
    ),
  });

  const { register, handleSubmit } = useForm<FormInputs>({
    resolver: yupResolver(formSchema),
  });

  const onSubmit = (payload: any) => {
    dispatch(UserLogin(payload));
  };

  useEffect(() => {
    if (login_status === true) {
      navigate(url + "/organizations", { replace: true });
    }
  }, [login_status, navigate]);

  if (login_status === true) {
    return <Spinner />;
  }

  if (session_loading) {
    return <Spinner />;
  }

  return (
    <>
      <div className="main-content">
        <section className="vh-100">
          <div className="container  h-100">
            <div className="row d-flex align-items-center justify-content-center h-100">
              <div className="col-md-8 col-lg-4 col-xl-6">
                <img src={loginImg} alt="" className="h-50 w-100" />
              </div>
              <div className="col-md-7 col-lg-5 col-xl-5 offset-xl-1">
                <div className="auth-wrapper d-flex no-block justify-content-center align-items-center">
                  <div className="auth-box p-4 bg-white rounded">
                    <div id="loginform">
                      <div className="logo">
                        <h3 className="box-title mb-3 text-color">Sign In</h3>
                      </div>
                      {/* Form */}

                      <div className="row">
                        <div className="col-12">
                          <form
                            className="form-horizontal mt-3 form-material"
                            id="loginform"
                            onSubmit={handleSubmit(onSubmit)}
                          >
                            <div className="form-group mb-3">
                              <div className="input-border">
                                <input
                                  className="form-control input-border text-color"
                                  type="text"
                                  placeholder="Username"
                                  {...register("email")}
                                />
                              </div>
                            </div>
                            <div className="form-group mb-4">
                              <div className="form-control input-border text-color">
                                <input
                                  className="form-control input-border"
                                  type="password"
                                  placeholder="Password"
                                  {...register("password")}
                                />
                              </div>
                            </div>
                            <div className="form-group">
                              <div className="d-flex">
                                <div className="ms-auto">
                                  <a
                                    href="/"
                                    id="to-recover"
                                    className="link font-weight-medium d-flex align-items-center"
                                  >
                                    <i className="ri-lock-line fs-5 me-1" />{" "}
                                    Forgot pwd?
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div className="form-group text-center mt-4 mb-3">
                              <div className="col-xs-12">
                                <button
                                  type="submit"
                                  className="
                    btn btn-info
                    d-block
                    w-100
                    waves-effect waves-light
                  "
                                >
                                  Log In
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Login;
